import PointTitles from '@/models/loyaltyPanel/PointTitles';
const getDefaultState = () => ({
  tiersLoading: false,
  pointTitles: [],
  pointTitle: new PointTitles(),
  tiers: [],
  tierValid: true,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setPointTitles(state, payload) {
      state.pointTitles = payload;
    },
    setTiersLoading(state, payload) {
      state.tiersLoading = payload;
    },

    setPointTitle(state, payload) {
      state.pointTitle = new PointTitles(payload);
    },

    setTiers(state, payload) {
      state.tiers = [...payload];
    },
    setTierValid(state, payload) {
      state.tierValid = payload;
    },
  },

  actions: {
    async fetchPointTitles({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        commit('setTiersLoading', true);

        const { data } = await PointTitles.get();
        const { titles, pagination } = data.data;
        if (titles[titles.length - 1]) {
          titles[titles.length - 1].to = null;
        }
        // titles.forEach(e => {
        //     e.store_point_title_id = undefined;
        //     e.created_at = undefined;
        //     e.updated_at = undefined;
        // });
        commit('setPointTitles', titles);
        commit('setTiers', titles);
        // commit("setServerItemsLength", pagination.total, {
        //     root: true
        // });
        commit('setLoading', false, { root: true });
        commit('setTiersLoading', false);
        return titles;
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async create({ commit, dispatch, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });
        let tiers = state.tiers.map((e, i) =>
          i === state.tiers.length - 1 ? { ...e, to: -1, multiplier: 1 } : { ...e, multiplier: 1 }
        );

        tiers.forEach((e) => {
          e.store_point_title_id = undefined;
          e.created_at = undefined;
          e.updated_at = undefined;
          e.errors = undefined;
          e.expiration_days =
            rootState.loyaltyPanel.tiers_settings.system == 'expiration_mode'
              ? e.expiration_days
              : undefined;
        });
        let res = await PointTitles.create({ tiers });

        dispatch('fetchPointTitles');
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created a new Point Title!',
          },
          { root: true }
        );
        commit('setLoading', false, { root: true });
        return res.data;
      } catch (ex) {
        console.log('ex', ex.response);
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex?.response?.data?.message || 'Error',
          },
          { root: true }
        );

        return ex?.response?.data;
      }
    },

    async update({ commit, dispatch, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });
        let tiers = state.tiers.map((e, i) =>
          i === state.tiers.length - 1 ? { ...e, to: -1, multiplier: 1 } : { ...e, multiplier: 1 }
        );
        tiers.forEach((e) => {
          e.store_point_title_id = undefined;
          e.created_at = undefined;
          e.updated_at = undefined;
          e.errors = undefined;
          e.expiration_days =
            rootState.loyaltyPanel.tiers_settings.system == 'expiration_mode'
              ? e.expiration_days
              : undefined;
        });
        let res = await PointTitles.update({ tiers });

        dispatch('fetchPointTitles');
        commit('setDialog', false, { root: true });
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully Updated Point Tiers!',
          },
          { root: true }
        );
        return res.data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });

        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        return ex?.response?.data;
      }
    },

    async remove({ commit, dispatch }, id) {
      try {
        commit('setLoading', true, { root: true });

        await PointTitles.delete(id);

        dispatch('fetchPointTitles');

        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'The Point Title is successfully deleted!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
